import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-items-center",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "done", -1)
const _hoisted_5 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "content_copy", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasContentToUse)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-icon btn-secondary",
        disabled: _ctx.isSubmitting,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveContentPageOverviewCb && _ctx.saveContentPageOverviewCb(...args)), ["prevent"]))
      }, [
        (_ctx.isSubmitting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : (_ctx.savedSuccessfully)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(_toDisplayString(_ctx.$t('savedSuccessfully') + '!'), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(_ctx.$t('useOnOverview')), 1)
              ]))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}